import React, { FC } from 'react';
import appConfiguration from 'Configuration';
import { withTheme } from 'theming';

import { Div, Header, Img } from 'MoshtixShared/component-element';
import { headerCss, logoContainerCss, logoCss } from './styles';

interface SimpleLogoHeaderProps {
  theme?: any;
}

const SimpleLogoHeaderWithoutTheme: FC<SimpleLogoHeaderProps> = ({ theme }) => {
  const moshtixLogoUrl = `//${appConfiguration.staticAssetsUrl}/images/moshtix-logo-nowhitespace.svg`;

  return (
    <Header css={headerCss({ theme })}>
      <Div css={logoContainerCss}>
        <a href={`//${appConfiguration.publicWebsiteOriginalUrl}`}>
          <Img alt="Moshtix" src={moshtixLogoUrl} css={logoCss} />
        </a>
      </Div>
    </Header>
  );
};

export const SimpleLogoHeader = withTheme(SimpleLogoHeaderWithoutTheme);

export default SimpleLogoHeader;
